import { Agency, agencyBasic } from '@app/models';
import { corridor } from '@app/pcs/models';
import { DictionaryEntity } from '@app/pcs/models/dictionary-entity';
import {gql} from 'apollo-angular';

export interface UsedCatalogData {
  cataloguePathSectionId?: number;
  cataloguePathNumber?: string;
  protectedBorder?: boolean;

  corridor?: any;
  cossAgency?: Agency;

  catalogueDossierId?: number;
  papId?: string;
  catalogueDossierType?: DictionaryEntity;
  catalogueProcessType?: DictionaryEntity;

  catalogSelectorAgency?: Agency;
  addedByAgency?: Agency;

  flex?: boolean;
  fix?: boolean;
  intermediate?: boolean;
  papRequestId?: number;
}

export const usedCatalogDataDetailed = gql`
    fragment usedCatalogDataDetailed on UsedCatalogData {
        cataloguePathSectionId
        cataloguePathNumber
        protectedBorder
        corridor {
            ...corridor
        }
        cossAgency {
            ...agencyBasic
            pathfinderMember
            unknownAgency
        }
        catalogueDossierId
        papId
        catalogueDossierType {
            id
            description
        }
        catalogueProcessType {
            id
            description
        }
        catalogSelectorAgency {
            ...agencyBasic
        }
        addedByAgency {
            ...agencyBasic
        }
        flex
        fix
        intermediate
        papRequestId
    }
    ${agencyBasic}
    ${corridor}
`;
